import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: Element
  Blocks: {
    default: []
  }
}
/**
 * Creating our own box shadow, as the built-in tailwind ones are directional,
 * whereas this provides an even shadow across all sides. */
export const ContentTile: TOC<Signature> = <template>
  <content-tile
    data-test-content-tile
    class="block overflow-hidden rounded-md shadow-[0_0_12px_rgba(209,208,208,1)] print:rounded-none print:border print:border-black print:shadow-none"
    ...attributes
  >
    {{yield}}
  </content-tile>
</template>

export default ContentTile
